module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_mellerud-64ea26a18589b80f4e05226245106c93.png";